<template>
  <div>

    <p class="mb-10 mt-10" style="font-size: 25pt; text-align: center">
      AGREGAR FUENTE DE DATOS INDICE
    </p>

    <v-card outlined>
      <v-toolbar flat>
        <v-btn @click="irAtras" icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title class="grey--text"
          >Agregar Información Ubicación Indice</v-toolbar-title
        >

        <!-- <v-spacer></v-spacer>

        <v-btn color="secondary">
          Agregar Información Ubicación
        </v-btn>-->
      </v-toolbar>

      <v-divider></v-divider>

      <v-card-text class="mb-4">
        <v-row>
          <v-col cols="12">
            <vue-code-highlight>
              <pre>
[
    {
      "IdUbication": 601, // Integer | Id de la ubicación del municipio
      "Value": 142, // Integer | Valor del indice para el año mas actualizado
    }
    ... //Se puede agregar uno a muchos a la vez
]
    </pre
              >
            </vue-code-highlight>
          </v-col>
        </v-row>
        <v-row v-show="dataIndice.length == 0">
          <v-col cols="12">
            <drop-zone @processedFile="resultProcessFile"></drop-zone>
          </v-col>
        </v-row>
        <v-row v-show="dataIndice.length > 0">
          <v-col cols="12">
            <v-jsoneditor
              v-model="dataIndice"
              :options="optionsEditor"
              height="400px"
            ></v-jsoneditor>
          </v-col>
        </v-row>
        <v-form ref="formDataLoad">
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="dataLoad.Fuente"
                label="Fuente Informacion"
                outlined
                hide-details="auto"
                required
                :rules="rules"
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="dataLoad.Ano"
                label="Año Publicación"
                outlined
                hide-details="auto"
                required
                type="number"
                :rules="rules"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="secondary"
              block
              large
              @click="addDataIndice(dataIndice)"
              :loading="loading"
              >Cargar Información</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-snackbar
      v-model="snackbar.show"
      bottom
      :color="snackbar.color"
      :timeout="5000"
      >{{ snackbar.text }}</v-snackbar
    >
  </div>
</template>

<script>
import api from "@/api/api";
import { component as VueCodeHighlight } from "vue-code-highlight";
// import "vue-code-highlight/themes/prism-twilight.css";
import "vue-code-highlight/themes/prism-tomorrow.css";
// import "vue-code-highlight/themes/window.css";
import VJsoneditor from "v-jsoneditor/src/index";
import dropZone from "@/components/Dropzone.vue";

export default {
  name: "Indices",
  components: {
    VueCodeHighlight,
    VJsoneditor,
    dropZone,
  },
  data() {
    return {
      idIndice: null,
      indice: null,
      dataIndice: [],
      optionsEditor: {
        mode: "preview",
      },
      dataLoad: {
        Fuente: null,
        Ano: null,
      },
      rules: [(v) => !!v || "Este campo es requerido"],
      snackbar: {
        show: false,
        text: null,
        color: null,
      },
      loading: false,
    };
  },
  mounted() {
    const idIndice = this.$route.params.idIndice;
    this.idIndice = idIndice;
    // this.getVariable(idVariable);
  },
  methods: {
    async addDataIndice(dataIndice) {
      try {
        if (dataIndice.length > 0) {
          if (this.$refs.formDataLoad.validate()) {
            this.loading = true;
            const data = await api.addDataIndice(
              this.idIndice,
              dataIndice,
              this.dataLoad
            );
            this.loading = false;
            if (data.status) {
              this.irAtras();
            }
          } else {
            this.showSnackbar("¡Completa los campos requeridos!", "error");
          }
        } else {
          this.showSnackbar(
            "Tienes que cargar un archivo JSON valido",
            "error"
          );
        }
      } catch (err) {
        console.log(err);
      }
    },
    async resultProcessFile(data) {
      this.dataIndice = data;
    },
    showSnackbar(message, color) {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    irAtras() {
      this.$router.go(-1);
    },
  },
};
</script>
